// React
import React from 'react';
// External
import { withRouter } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';
// Internal
import NavbarPrimary from 'components/shared/organisms/NavbarPrimary/NavbarPrimary';
import PageTitle from 'components/shared/atoms/PageTitle/PageTitle';
import ContentCard from 'components/shared/organisms/ContentCard/ContentCard';
// Style
import './styles.scss';

function Engraving404() {
    return (
        <div className="main-container">
            <NavbarPrimary hideNav />
            <div className="body-content">
                <PageTitle title="Engraving Approval" />

                <ContentCard
                    className="mt-62"
                    headerTitle="Editing your engraving is no longer available"
                    headerStyle={{ marginBottom: '30px' }}
                    divider={false}
                >
                    <Container fluid className="engraving-container">
                        <Row>
                            <Col md={6}>
                                <p>
                                    Thank you for checking on the status of your product engraving. Your order has since
                                    progressed and engraving changes are no longer available.
                                </p>
                                <p>
                                    If you wish to discuss your order further, please contact Lawnswood Customer Care on
                                    XXXX XXXX.
                                </p>
                            </Col>
                            <Col md={6}>
                                <div className="engraving-canvas" />
                            </Col>
                        </Row>
                    </Container>
                </ContentCard>
            </div>
        </div>
    );
}

export default withRouter(Engraving404);
